<template>
  <b-modal
    :no-close-on-backdrop="true"
    id="alertmodal"
    size="md"
    body-class="bg-white"
    cancel-title="Cancel"
    cancel-variant="light"
    :hide-header="true"
    :hide-footer="true"
    @show="submitted= false"
    ref="alertmodal"
  >
    <div class="display-flex">
      <i class="fa fa-exclamation-triangle" style="font-size:32px;color:#f98a00"></i>
      <p class="pl-2">{{ content }}</p>
    </div>
    <b-button @click="alertmodal" variant="success" class="btn-sm">
      <i class="fa fa-circle-o-notch fa-spin mr-2" v-if="submitted==true"></i>Okay
    </b-button>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      submitted: false
    };
  },
  props: ["content", "title", "callback"],
  methods: {
    async alertmodal() {
      this.submitted = true;
      if (this.callback) {
        this.$emit("setAlertSuccess");
      }

      await this.$refs.alertmodal.hide();
    }
  }
};
</script>

<style>
</style>
